import DetailModel from './DetailModel';

export default class CallTraceModel {
    /**
     * @param {object} callTrace
     * @param {array} listAA
     * @param {array} listCT
     */
    constructor(callTrace, listAA, listCT) {
        this.id = callTrace.calltrace_id;
        this.startTime = callTrace.start_time ? new Date(callTrace.start_time) : undefined;
        this.endTime = callTrace.end_time ? new Date(callTrace.end_time) : undefined;
        this.location = callTrace.location;
        this.incomplete = callTrace.incomplete;
        this.categories = callTrace.categories;
        this.details = callTrace.details.map(detail => new DetailModel(detail, this));
        this.cacheAccepted = callTrace.cache_accepted ? new Date(callTrace.cache_accepted) : undefined;
        this.cacheCatChanged = callTrace.cache_cat_changed
            ? new Date(callTrace.cache_cat_changed)
            : undefined;
        this.cacheNP = callTrace.cache_np ? new Date(callTrace.cache_np) : undefined;

        this.listAA = listAA;
        this.listCT = listCT;

        this.nameAA = this.getAAName();
        this.category = this.getCategory();
    }

    /**
     * Gets location name
     * @returns {string} location name
     */
    getLocation() {
        return this.location;
    }

    /**
     * Gets category object
     * @returns {object} Category
     */
    getCategory() {
        return this.listCT.find(item => this.categories.length > 0 && this.categories[0] === item.id);
    }

    /**
     * Gets assignment area name
     * @returns {string} Assignment area name
     */
    getAAName() {
        let aa = this.listAA.find(aa => aa.locations.some(ll => ll.name === this.location));

        return aa ? aa.name : '';
    }

    /**
     * Gets accepted detail object
     * @returns {object} DetailModel
     */
    getAcceptedDetail() {
        return this.details.find(detail => detail.key === 'callAccepted');
    }

    /**
     * Gets presence on object
     * @returns {object} DetailModel
     */
    getNursePresenceOnDetail() {
        return this.details.find(detail => ['nursePresent', 'nursePresentStaff'].includes(detail.key));
    }

    /**
     * Gets presence off object
     * @param nursePresenceOnDetail
     * @returns {object} DetailModel
     */
    getNursePresenceOffDetail(nursePresenceOnDetail) {
        return this.details.find(
            detail =>
                ['nursePresentCancel', 'nursePresentCancelStaff'].includes(detail.key) &&
                nursePresenceOnDetail.params[0] === detail.params[0]
        );
    }

    /**
     * Gets assistance on object
     * @returns {object} DetailModel
     */
    getAssistanceOnDetail() {
        return this.details.find(detail => detail.key === 'call' && detail.params.includes('Assistance'));
    }

    /**
     * Gets assistance off object
     * @returns {object} DetailModel
     */
    getAssistanceOffDetail() {
        return this.details.find(
            detail =>
                ['callCancel', 'callCancelRemote'].includes(detail.key) &&
                detail.params.includes('Assistance')
        );
    }
}
